import ReactGA from "react-ga";
import ReactPixel from "react-fb-pixel";

if (process.env.REACT_APP_BUILD_ENV === "production") {
  ReactGA.initialize(process.env.REACT_APP_GA);
  ReactPixel.init(process.env.REACT_APP_FB_PIXEL_ID_SG, {}, { autoConfig: true, debug: true });
  console.log("Production build will track pages");
}

export function trackPage(path) {
  if (process.env.REACT_APP_BUILD_ENV !== "production") {
    return false;
  }
  ReactPixel.pageView();
  ReactGA.pageview(path);
  return true;
}

export function initPixel(country) {
  if (process.env.REACT_APP_BUILD_ENV !== "production") {
    return false;
  }
  ReactPixel.init(
    country === "my" ? process.env.REACT_APP_FB_PIXEL_ID_MY : process.env.REACT_APP_FB_PIXEL_ID_SG,
    {},
    { autoConfig: true, debug: true }
  );
}

export function trackCustom(event, country, data) {
  if (process.env.REACT_APP_BUILD_ENV !== "production") {
    return false;
  }
  ReactPixel.init(
    country === "my" ? process.env.REACT_APP_FB_PIXEL_ID_MY : process.env.REACT_APP_FB_PIXEL_ID_SG,
    {},
    { autoConfig: true, debug: true }
  );
  ReactPixel.track(event, { country: country, data: data });
}
